import PropTypes from 'prop-types';
import React, { PureComponent, Component } from 'react';

// Sizer uses an iframe to reliably report the size of its parent element
// It works robustly even when the page resizes or reflows
export default class Sizer extends Component {
    constructor(props) {
        super(props);
        this.ref = this.ref.bind(this);
        this.state = {
            size: null,
        };
    }

    ref(iframe) {
        if (iframe) {
            const update = (window.onresize = () => {
                const box = iframe.getBoundingClientRect();
                const size = { width: box.width, height: box.height };
                this.setState({ size });
                this.props.onSize(size);
            });
            update();
        }
    }

    render() {
        return [
            <iframe
                title="sizer"
                style={{
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    width: '100%',
                    height: '100%',
                    margin: '0 0',
                    border: 'none',
                    opacity: '0',
                    visibility: 'hidden',
                    pointerEvents: 'none',
                }}
                ref={this.ref}
                key="sizer"
            />,
            this.state.size !== null ? this.props.render(this.state.size) : null,
        ];
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/DesignPane/Sizer.jsx